export default {
  state: {
    data: {},
  },
}
